import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.sass';

const Spinner = ({ size, color }) => (
  <div
    className={styles.spinner}
    style={{
      height: `${size}px`,
      width: `${size}px`,
    }}
  >
    <div className={styles.spinnerSpoke} style={{ backgroundColor: color }} />
    <div className={styles.spinnerSpoke} style={{ backgroundColor: color }} />
    <div className={styles.spinnerSpoke} style={{ backgroundColor: color }} />
    <div className={styles.spinnerSpoke} style={{ backgroundColor: color }} />
    <div className={styles.spinnerSpoke} style={{ backgroundColor: color }} />
    <div className={styles.spinnerSpoke} style={{ backgroundColor: color }} />
    <div className={styles.spinnerSpoke} style={{ backgroundColor: color }} />
    <div className={styles.spinnerSpoke} style={{ backgroundColor: color }} />
    <div className={styles.spinnerSpoke} style={{ backgroundColor: color }} />
    <div className={styles.spinnerSpoke} style={{ backgroundColor: color }} />
    <div className={styles.spinnerSpoke} style={{ backgroundColor: color }} />
    <div className={styles.spinnerSpoke} style={{ backgroundColor: color }} />
  </div>
);

Spinner.propTypes = {
  size: PropTypes.number,
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Spinner.defaultProps = {
  size: 40,
  color: 'black',
};

export const CenteredSpinner = props => (
  <div className={styles.centered}>
    <Spinner {...props} />
  </div>
);

export default Spinner;
